// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "hr{background:#fff;border:none;height:2px;margin:50px auto;width:60%}@media screen and (min-width:48em){hr{margin:60px auto;width:40%;max-width:430px}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
